import $ from 'jquery';

$(function () {
    $('.partner-questionnaire').each(function () {
        const $form = $(this);
        const $coverage = $form.find('#partner-coverage');
        const $states = $form.find('#partner-states');

        const updateStates = function () {
            const regional = $coverage.val() === 'Regional';
            $states.toggleClass('is-hidden', !regional);
        };

        $coverage.on('change', updateStates);
        updateStates();

        $form.on('click', '#btn-toggle-all-states', function (e) {
            e.preventDefault();
            const $checkboxes = $states.find('input[type="checkbox"]');
            const allChecked = $checkboxes.filter(':checked').length === $checkboxes.length;
            $checkboxes.prop('checked', !allChecked).trigger('change');
        });

        // Ja / Nein Radio Options handling
        const updateRadioSelectedState = function () {
            $form.find('.form-radio-options input[type="radio"]').each(function () {
                $(this).closest('.form-check').toggleClass('is-selected', this.checked);
            });
        };

        $form.on('change', '.form-radio-options input[type="radio"]', function () {
            updateRadioSelectedState();
        });

        $form.on('click', '.form-radio-options .form-check', function (e) {
            if (!$(e.target).is('input')) {
                const $input = $(this).find('input[type="radio"]');
                if (!$input.prop('checked')) {
                    $input.prop('checked', true).trigger('change');
                }
            }
        });

        updateRadioSelectedState();

        // Checkbox Options handling (Gewerke & Bundesländer)
        const updateCheckboxSelectedState = function () {
            $form.find('.form-choice-options input[type="checkbox"], .partner-states input[type="checkbox"]').each(function () {
                $(this).closest('.form-check').toggleClass('is-selected', this.checked);
            });
        };

        $form.on('change', '.form-choice-options input[type="checkbox"], .partner-states input[type="checkbox"]', function () {
            updateCheckboxSelectedState();
        });

        $form.on('click', '.form-choice-options .form-check, .partner-states .form-check', function (e) {
            if (!$(e.target).is('input, label')) {
                const $input = $(this).find('input[type="checkbox"]');
                $input.prop('checked', !$input.prop('checked')).trigger('change');
            }
        });

        updateCheckboxSelectedState();
    });
});
